import React, {FunctionComponent, useContext} from 'react';
import styled from 'styled-components';

import {SVGAuthors} from '../../../atoms/svgs/authors';
import {MessageContext} from '../../../utils/message';

import {HorizontalSection, VerticalSection, List, LabelField, NameField, InfoField, Infos} from './ui';

interface Author {
    name: string;
    image?: string;
    info: string;
}

type LayoutDirection = 'inline' | 'block';

export interface ContentWrittenByProps {
    authors: Author[];
    direction?: LayoutDirection;
    className?: string;
}

const RawContentWrittenBy: FunctionComponent<ContentWrittenByProps> = ({authors, direction = 'inline', className}) => {
    if (authors.length === 0) {
        return null;
    }

    const {getText} = useContext(MessageContext);

    const images = authors.map((author) => author.image);

    const Section = direction === 'inline' ? HorizontalSection : VerticalSection;

    return (
        <Section className={className}>
            {authors.length > 0 && <SVGAuthors id="authors" overlap={0.25} images={images} />}

            <List>
                <LabelField>{getText('content.writtenby.by')}</LabelField>
                {authors.map(({name, info}, index, arr) => (
                    <Infos key={`name_${index}`} isLast={arr.length - 1 === index}>
                        <NameField>{name}</NameField>
                        {info && <InfoField>({info})</InfoField>}
                    </Infos>
                ))}
            </List>
        </Section>
    );
};

export const ContentWrittenBy = styled(RawContentWrittenBy)``;
